import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";

function F003Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionSubCode}_Q001`}
          subsectionLabel="C2"
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="C2 fx"
                name={`${sectionDelimiter}Q001A001`}
                type="option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="dens:"
                name={`${sectionDelimiter}Q001A002`}
                type="option"
              />
              <ChartRowElement
                label="Type I"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A003`}
                type="option"
              />
              <ChartRowElement
                label="Type II"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A004`}
                type="option"
              />
              <ChartRowElement
                label="Type III"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A005`}
                type="option"
              />
              <ChartRowElement
                label="extension teardrop"
                name={`${sectionDelimiter}Q001A006`}
                type="option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A007`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="traumatic spondylo (hangman fx):"
                name={`${sectionDelimiter}Q001A008`}
                type="option"
              />
              <ChartRowElement
                label="Type I"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A009`}
                type="option"
              />
              <ChartRowElement
                label="Type II"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A010`}
                type="option"
              />
              <ChartRowElement
                label="Type IIA"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A011`}
                type="option"
              />
              <ChartRowElement
                label="Type III"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A012`}
                type="option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A013`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="stable"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A014`}
                type="option"
              />
              <ChartRowElement
                label="unstable"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A015`}
                type="option"
              />
              <ChartRowElement
                label="nondisplaced"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A016`}
                type="option"
              />
              <ChartRowElement
                label="displaced"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A017`}
                type="option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A018`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                name={`${sectionDelimiter}Q001A019`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { F003Interpretation };
